import { render, staticRenderFns } from "./CreatedRuleFeedback.vue?vue&type=template&id=3facb63a&scoped=true&"
import script from "./CreatedRuleFeedback.vue?vue&type=script&lang=js&"
export * from "./CreatedRuleFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3facb63a",
  null
  
)

export default component.exports